import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'staff-info',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule
  ],
  templateUrl: './staff-info.component.html',
  styleUrl: './staff-info.component.css'
})
export class StaffInfoComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerInterviewDate') datepickerInterviewDate!: ElementRef;
  staffInfoForm: FormGroup = new FormGroup([]);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.staffInfoForm = new FormGroup({
      staff_interviewed: new FormControl(this.teacherStaffInterviewData?.staff_interviewed || '', Validators.required),
      date_interview: new FormControl(this.teacherStaffInterviewData?.date_interview || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required),
      time_interview: new FormControl(this.teacherStaffInterviewData?.time_interview || '11:00', Validators.required),
      person_conducting_interview: new FormControl(this.teacherStaffInterviewData?.person_conducting_interview || '', Validators.required),
    });
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerInterviewDate) {
        new Datepicker(this.datepickerInterviewDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.teacherStaffInterviewData?.date_interview) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerInterviewDate.nativeElement.value = DateUtils.formatDateForDisplay(this.teacherStaffInterviewData.date_interview);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerInterviewDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerInterviewDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.staffInfoForm.get('date_interview')?.setValue(formattedDate);
        });
      }
    }
  }

  saveStaffInfo(): void {
    if (this.staffInfoForm.valid) {
      this.onSaveSection1.emit(this.staffInfoForm.value);
    }
  }

}
